<template>
    <page>
		<module enable-flex>
      <m-search ref="search" @search="searchHandle">
        <c-form>
          <c-form-item type="input" label="标题" name="name"></c-form-item>
          <c-form-item type="datetime" label="发布时间" start-name="start_create_date" end-name="end_create_date"></c-form-item>
        </c-form>
      </m-search>
			<m-operate>
				<c-button color="sys" icon="add" @click="navigateTo(`/newsinfo_add`)" power="b_basicinfo_news_info_add">添加新闻</c-button>
			</m-operate>
			
			<c-table ref="table" code="basicinfo_news_info_list">
        <c-table-column
            label="标题"
            name="name"
			width="400"
        >
        </c-table-column>
        <c-table-column
            label="发布时间"
            name="create_date"
			width="140"
        >
        </c-table-column>
        <c-table-column
            label="状态"
            name="state"
			width="60"
        >
          <template v-slot="{data}">
            <span style="color:darkgreen" v-if="data.state==2">启用</span>
            <span style="color:red" v-else>禁用</span>
          </template>
        </c-table-column>
				
				<c-table-column
					type="sort"
					label="排序"
					@sort="sortHandle"
				></c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="160"
				>
          <template v-slot="{data}">
            <c-table-button power="b_platform_user_state" v-if="data.state == 1"  @click="updateState(2,data)">启用</c-table-button>
            <c-table-button power="b_platform_user_state" v-if="data.state == 2"  @click="updateState(1,data)">禁用</c-table-button>
            <c-table-button @click="navigateTo(`/newsinfo_edit/${data.id}`)" power="b_basicinfo_news_info_edit">编辑</c-table-button>
						<c-table-button @click="deleteHandle(data)" power="b_basicinfo_news_info_del">删除</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		
<!--		<c-dialog ref="dialog" :title="editState ? '编辑分类' : '添加分类'" width="600" height="300" @resolve="addChild">-->
<!--			<c-form ref="form">-->
<!--				<c-form-item type="input" label="分类名称" name="type_name" required></c-form-item>-->
<!--			</c-form>-->
<!--		</c-dialog>-->
	</page>
</template>

<script>
  var name = 'm_basicinfo_news_info';
  var urls = {
    list:'/news_info/list', //列表数据
    del:'/news_info/del', //删除
    sort:'/news_info/sort', //排序
    state:'/news_info/state', //启禁用
  }
	export default {
		name: name,
		
		data() {
			return {
				editState: false
			}
		},
		
		mounted() {
			// this.$refs.table.load({
			// 	url: '/news_info/list',
			// 	// data: {
			// 	// 	parent_id: 0
			// 	// }
			// });
      this.$refs.search.search();

      this.$bus.$on(name+'.update', page => {
        this.$refs.table.update(page);
      });
		},
		
		methods: {
      searchHandle(data) {
        this.$refs.table.load({
          url: urls.list,
          data
        });
      },
			// loadChildren(row, resolve) {
			// 	this.request({
			// 		url: '/product_type/list',
			// 		data: {
			// 			parent_id: row.data.id
			// 		},
			// 		success: data => {
			// 			resolve(data || []);
			// 		}
			// 	});
			// },
			
			// addHandle(row, resolve) {
			// 	this.editState = false;
			// 	this._edit = 0;
			// 	this._parent = row ? row.data.id : 0;
			// 	this._resolve = data => {
			// 		row ? resolve(data) : this.$refs.table.push(data);
			// 	};
			// 	this.$refs.form.clear();
			// 	this.$refs.dialog.open();
			// },
			//
			editHandle(row) {
				this.editState = true;
				this._edit = row.data.id;
				this._resolve = data => {
					row.update(data);
				};
				this.$refs.form.set(row.data);
				this.$refs.dialog.open();
			},

      updateState(type,val) {
        // var val = row.data;
        this.$confirm({
          text: '确定要'+(type==2?'启用':'禁用')+'【'+val.name+'】吗？',  // 提示内容,
          buttonName: '确定',  // 确定按钮文字
          cancelButton: true,  // 是否显示取消按钮
          resolve: () => {
            this.request({
              url: urls.state,
              data: {id:val.id,state:type},
              loading: true,
              success: data => {
                this.$message({
                  text: '操作成功',
                  icon: 'success'
                });
                this.$refs.table.update();
              }
            });
          },  // 确定按钮回调
          cancel: () => {},  // 取消按钮回调
        });
      },
			
			deleteHandle(val) {
				// this.request({
				// 	url: '/news_info/del',
				// 	data: {
				// 		id: row.data.id
				// 	},
				// 	loading: true,
				// 	success: data => {
				// 		this.$message({
				// 			text: '删除成功'
				// 		});
        //     this.$refs.search.search();
				// 	}
				// });
        this.$confirm({
          text: '确定要删除【'+val.name+'】吗？',  // 提示内容,
          buttonName: '确定',  // 确定按钮文字
          cancelButton: true,  // 是否显示取消按钮
          resolve: () => {
            this.request({
              url: urls.del,
              data: {id:val.id},
              loading: true,
              success: data => {
                this.$message({
                  text: '操作成功',
                  icon: 'success'
                });
                this.$refs.table.update();
              }
            });
          },  // 确定按钮回调
          cancel: () => {},  // 取消按钮回调
        });
			},
			
			sortHandle(row, type, next) {
				this.request({
					url: urls.sort,
					data: {
						id: row.data.id,
						parent_id: row.expandData.parent ? row.expandData.parent.data.id : 0,
						type: ['top', 'bottom'].includes(type) ? type : '',
						id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
						id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
					},
					loading: true,
					success: data => {
                        if (type == 'top' || type == 'bottom') {
                            this.$refs.table.update();
                        } else {
                            next();
                        }
					}
				});
			},
			
			// addChild(stop) {
			// 	stop();
			// 	var data = this.$refs.form.serialize();
			// 	if (!data.type_name) {
			// 		this.$message({
			// 			text: '请填写分类名称'
			// 		});
			// 		return;
			// 	}
			//
			// 	this.request({
			// 		url: this._edit ? '/product_type/batch_edit' : '/product_type/add',
			// 		data: this._edit ? {
			// 			data_list: [Object.assign(data, {
			// 				id: this._edit,
			// 				parent_id: this._parent
			// 			})]
			// 		} : Object.assign(data, {
			// 			parent_id: this._parent
			// 		}),
			// 		loading: true,
			// 		success: data => {
			// 			this.$message({
			// 				text: this._edit ? '编辑成功' : '添加成功'
			// 			});
			// 			this.$refs.dialog.close();
			// 			this._resolve(data);
			// 		}
			// 	});
			// }
		}
	}
</script>